import { Icon, Tooltip } from 'components/common';
import { colours } from 'utils/theme';

// Tradeshows section title shown while isMissingTradeshowFlag holds.
const TradeshowFlagsWarning = () => (
  <div
    data-testid='tradeshow-flags-warning'
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'unset',
      flex: 1,
    }}
  >
    Tradeshows
    <Tooltip
      defaultOpen
      placement='right'
      overlayStyle={{ maxWidth: 350 }}
      title={
        <p>
          Please select a filter below for exhibiting or presenting at a
          tradeshow, or to only search these tradeshows presentations.
        </p>
      }
    >
      <div style={{ marginLeft: 5 }}>
        <Icon icon='error' size='sm' color={colours.orange} />
      </div>
    </Tooltip>
  </div>
);

export default TradeshowFlagsWarning;
